export default __webpack_public_path__ + "static/ComprehensiveEnvironmentalProtectionOrdinance-11aaa80bf195f074253848a3716f5fe1.jpg";